export default __webpack_public_path__ + "static/media/logo.49fc3696.png";